import { BaseConnector } from './baseConnector';

class HearingTypeConnector extends BaseConnector {
  getHearingTypes() {
    var url = `${this.baseApiUrl}/hearingType`;
    return this.authFetch(url);
  }

  createHearingType(hearingType) {
    var url = `${this.baseApiUrl}/hearingType`;
    return this.authPost(url, hearingType);
  }

  updateHearingType(hearingTypeId, hearingType) {
    var url = `${this.baseApiUrl}/hearingType/${hearingTypeId}`;
    return this.authPatch(url, hearingType);
  }

  deleteHearingType(hearingTypeId) {
    var url = `${this.baseApiUrl}/hearingType/${hearingTypeId}`;
    return this.authDelete(url);
  }
}

export { HearingTypeConnector };
